'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TutorController = function () {

  /*@ngInject*/
  function TutorController($http, $scope, Modal, JSONToCSVConvertor) {
    _classCallCheck(this, TutorController);

    this.$http = $http;
    this.Modal = Modal;
    this.JSONToCSVConvertor = JSONToCSVConvertor;
  }

  _createClass(TutorController, [{
    key: '$onInit',
    value: function $onInit() {
      this.grab();
    }
  }, {
    key: 'grab',
    value: function grab() {
      var _this = this;

      this.$http.get('/api/tutors').then(function (response) {
        _this.tutors = response.data;
      });
    }
  }, {
    key: 'export',
    value: function _export(data) {
      this.JSONToCSVConvertor(data, 'Tutor Export', true);
    }
  }, {
    key: 'addTutor',
    value: function addTutor(newTutor) {
      var _this2 = this;

      if (newTutor) {
        newTutor.fullName = newTutor.firstName + ' ' + newTutor.lastName;
        this.$http.post('/api/tutors', newTutor).then(function (res) {
          _this2.grab();
          _this2.error = '';
        }).catch(function (res) {
          _this2.error = JSON.stringify(res.data, null, '\t');
        });
      }
    }
  }, {
    key: 'toggleActive',
    value: function toggleActive(tutor) {
      tutor.isActive = !tutor.isActive;
      this.$http.put('/api/tutors/' + String(tutor._id), { isActive: tutor.isActive });
    }
  }, {
    key: 'patchTutor',
    value: function patchTutor(tutor, callback) {
      var _this3 = this;

      if (tutor) {
        tutor.fullName = tutor.firstName + ' ' + tutor.lastName;
        this.$http.put('/api/tutors/' + String(tutor._id), tutor).then(function (res) {
          _this3.grab();
          _this3.error = '';
          callback();
        }).catch(function (res) {
          _this3.error = JSON.stringify(res.data, null, '\t');
        });
      }
    }
  }, {
    key: 'openModal',
    value: function openModal(tutor) {
      this.Modal.editTutor(tutor);
    }
  }]);

  return TutorController;
}();

exports.default = TutorController;


// WEBPACK FOOTER //
// ./client/app/admin/tutor/tutor.controller.js